import { type InsertPoentialHighQuality, api } from '@here/api'

export const createPotentialHighQualityPost = async (
	potentialHighQuality: InsertPoentialHighQuality,
) => {
	const { data, error } = await api()
		.from('potential_high_quality')
		.insert(potentialHighQuality)

	if (error) {
		// handle error
	}

	return data
}
